<template>
  <div class="mt-1">
    <div class="is-flex is-flex-direction-row">
      <b-progress
        type="is-success"
        :value="avance"
        format="percent"
        :precision="1"
        show-value
        class="is-flex-grow-1 mb-0"
      ></b-progress>
      <b-tooltip
        v-if="status && status.tieneError"
        :label="status?.mensaje"
        type="is-danger"
        position="is-top"
      >
        <b-icon
          icon="exclamation-triangle"
          size="is-small"
          type="is-danger"
          class="ml-1"
        ></b-icon>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import * as signalR from '@microsoft/signalr'

import { tareasService } from '@/services'

export default {
  name: 'RecuentoStatus',
  props: {
    recuento: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      status: null,
      reconectando: false,
      connection: null
    }
  },
  computed: {
    avance() {
      if (this.status?.porcentajeEjecucion === undefined) return 0
      return this.status.porcentajeEjecucion
    },
    identificador() {
      return `recuento-${this.recuento}`
    }
  },
  created() {
    this.getTareasStatus()
    this.createHub()
  },
  beforeDestroy() {
    this.stopHub()
  },
  methods: {
    getTareasStatus() {
      tareasService
        .getStatusTareasByIdentificador(this.identificador)
        .then((response) => {
          this.status = response.data
        })
        .catch((error) => this.procesarError(error))
    },
    async createHub() {
      const self = this
      const url = `${process.env.VUE_APP_BASE_URL}hubs/tareas`
      if (this.connection) {
        await this.disableHub()
        await this.stopHub()
      }
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          accessTokenFactory: () => localStorage.getItem('token') || ''
        })
        .withAutomaticReconnect([5000, 5000, 10000, 10000, 10000, 10000, 10000])
        .configureLogging(
          process.env.NODE_ENV === 'development'
            ? signalR.LogLevel.Information
            : signalR.LogLevel.Error
        )
        .build()
      this.connection.onreconnecting(() => (self.reconectando = true))
      this.connection.onreconnected(() => (self.reconectando = false))
      this.connection.onclose(() => {
        if (
          self.connection &&
          self.connection.state === 'Disconnected' &&
          self.reconectando
        ) {
          self.notificarError(
            'Se perdió la conexión con el servidor. Se volverá a intentar luego.'
          )
          setTimeout(() => {
            self.startHub()
          }, 30000)
        }
      })
      this.startHub().then((_) => this.enableHub())
    },
    startHub() {
      const self = this
      return this.connection
        .start()
        .then((_) => {
          self.connection
            .invoke('conectar-status-tareas', this.identificador)
            .catch((err) => {
              self.notificarError(err.toString())
            })
        })
        .catch((err) => {
          if (err.statusCode === 401) {
            if (!self.$store.getters['sesion/esValida']) {
              this.$router.push('/login').catch(() => {})
            } else {
              return self.$store.dispatch('sesion/refreshToken')
            }
          } else {
            self.procesarError(err)
          }
        })
    },
    async stopHub() {
      const self = this
      if (this.connection.state !== 'Disconnected')
        await this.connection
          .invoke('desconectar-status-tareas', this.identificador)
          .catch((err) => {
            self.notificarError(err.toString())
          })
          .then(async (_) => self.connection.stop())
    },
    async disableHub() {
      const self = this
      await self.connection.off('UpdateStatus')
    },
    enableHub() {
      const self = this
      self.connection.on('UpdateStatus', () =>
        self.$nextTick(() => self.getTareasStatus())
      )
    }
  }
}
</script>
